export var ArticleHelpfulState;
(function (ArticleHelpfulState) {
    ArticleHelpfulState[ArticleHelpfulState["NOT_HELPFUL"] = -1] = "NOT_HELPFUL";
    ArticleHelpfulState[ArticleHelpfulState["NONE"] = 0] = "NONE";
    ArticleHelpfulState[ArticleHelpfulState["HELPFUL"] = 1] = "HELPFUL";
})(ArticleHelpfulState || (ArticleHelpfulState = {}));
//# sourceMappingURL=article-helpful-state.i.js.map